"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SankeyDataPropTypes = exports.TagsCatalogPropTypes = exports.TagsGroupPropTypes = exports.SankeyLabelPropTypes = exports.SankeyLinkPropTypes = exports.SankeyLinkValueDictTypes = exports.SankeyLinkValueTypes = exports.SankeyNodePropTypes = void 0;
const prop_types_1 = __importDefault(require("prop-types"));
exports.SankeyNodePropTypes = {
    // identification
    idNode: prop_types_1.default.string.isRequired,
    name: prop_types_1.default.string.isRequired,
    //- level attributes
    dimensions: prop_types_1.default.objectOf(prop_types_1.default.shape({
        parent_name: prop_types_1.default.string,
        level: prop_types_1.default.number,
    }).isRequired).isRequired,
    // DISPLAY ATTRIBUTES
    // display controls the agregation desagregation process. 
    display: prop_types_1.default.bool.isRequired,
    // node_visible controls the other process in particular tags manipulations
    node_visible: prop_types_1.default.bool.isRequired,
    // shape_visible and label_visible control the visibility of the element of the node
    shape_visible: prop_types_1.default.bool.isRequired,
    label_visible: prop_types_1.default.bool.isRequired,
    node_width: prop_types_1.default.number.isRequired,
    node_height: prop_types_1.default.number.isRequired,
    iconName: prop_types_1.default.string.isRequired,
    iconColor: prop_types_1.default.string.isRequired,
    iconRatio: prop_types_1.default.number.isRequired,
    iconVisible: prop_types_1.default.bool.isRequired,
    color: prop_types_1.default.string.isRequired,
    colorParameter: prop_types_1.default.string.isRequired,
    colorTag: prop_types_1.default.string.isRequired,
    // geometry
    position: prop_types_1.default.oneOf(['absolute', 'relative']).isRequired,
    x: prop_types_1.default.number.isRequired,
    y: prop_types_1.default.number.isRequired,
    x_label: prop_types_1.default.number,
    y_label: prop_types_1.default.number,
    show_value: prop_types_1.default.bool.isRequired,
    tooltip_text: prop_types_1.default.string,
    // topology
    inputLinksId: prop_types_1.default.arrayOf(prop_types_1.default.string.isRequired).isRequired,
    outputLinksId: prop_types_1.default.arrayOf(prop_types_1.default.string.isRequired).isRequired,
    // semantic
    shape: prop_types_1.default.oneOf(['ellipse', 'rect']).isRequired,
    tags: prop_types_1.default.objectOf(prop_types_1.default.arrayOf(prop_types_1.default.string.isRequired).isRequired).isRequired,
    style: prop_types_1.default.string.isRequired,
    //display
    display_style: prop_types_1.default.shape({
        font_family: prop_types_1.default.string.isRequired,
        font_size: prop_types_1.default.number.isRequired,
        uppercase: prop_types_1.default.bool.isRequired,
        bold: prop_types_1.default.bool.isRequired,
        italic: prop_types_1.default.bool.isRequired,
        unit: prop_types_1.default.bool.isRequired,
        filter: prop_types_1.default.number.isRequired,
        filter_label: prop_types_1.default.number.isRequired,
        global_curvature: prop_types_1.default.number.isRequired,
        null_flux: prop_types_1.default.bool.isRequired,
        label_vert: prop_types_1.default.string.isRequired,
        label_horiz: prop_types_1.default.string.isRequired,
        label_vert_valeur: prop_types_1.default.string.isRequired,
        label_horiz_valeur: prop_types_1.default.string.isRequired,
        value_font_size: prop_types_1.default.number.isRequired,
        label_box_width: prop_types_1.default.number.isRequired
    }).isRequired,
};
exports.SankeyLinkValueTypes = {
    value: prop_types_1.default.any,
    display_value: prop_types_1.default.string.isRequired,
    // corresponding to tag_favorite. to be used in conjunction with colorTag
    //  const selected_tag = getLinkValue(data,l.idLink).tags[l.colorTag]
    tags: prop_types_1.default.objectOf(prop_types_1.default.string.isRequired).isRequired,
    // for previous_value, data_value, data_source, data_period, mini, maxi ...
    extension: prop_types_1.default.objectOf(prop_types_1.default.string.isRequired)
};
exports.SankeyLinkValueDictTypes = prop_types_1.default.objectOf(prop_types_1.default.shape(exports.SankeyLinkValueTypes).isRequired).isRequired;
exports.SankeyLinkPropTypes = {
    // identification
    idLink: prop_types_1.default.string.isRequired,
    idSource: prop_types_1.default.string.isRequired,
    idTarget: prop_types_1.default.string.isRequired,
    // type of link
    recycling: prop_types_1.default.bool,
    orientation: prop_types_1.default.string.isRequired,
    arrow: prop_types_1.default.bool.isRequired,
    // display_attribute
    label_position: prop_types_1.default.string.isRequired,
    orthogonal_label_position: prop_types_1.default.string.isRequired,
    label_on_path: prop_types_1.default.bool.isRequired,
    label_visible: prop_types_1.default.bool.isRequired,
    text_color: prop_types_1.default.string.isRequired,
    color: prop_types_1.default.string.isRequired,
    colorParameter: prop_types_1.default.string.isRequired,
    colorTag: prop_types_1.default.string.isRequired,
    // Ajout
    gradient: prop_types_1.default.bool.isRequired,
    dashed: prop_types_1.default.bool.isRequired,
    value: prop_types_1.default.oneOfType([exports.SankeyLinkValueDictTypes, prop_types_1.default.shape(exports.SankeyLinkValueTypes).isRequired]).isRequired,
    tooltip_text: prop_types_1.default.string,
    // geometry
    x_label: prop_types_1.default.number,
    y_label: prop_types_1.default.number,
    left_horiz_shift: prop_types_1.default.number,
    right_horiz_shift: prop_types_1.default.number,
    vert_shift: prop_types_1.default.number,
    shift_gap: prop_types_1.default.number.isRequired,
    curvature: prop_types_1.default.number.isRequired,
    curved: prop_types_1.default.bool.isRequired,
    //style
    style: prop_types_1.default.string.isRequired
};
exports.SankeyLabelPropTypes = {
    // identification
    idLabel: prop_types_1.default.string.isRequired,
    name: prop_types_1.default.string.isRequired,
    transparent: prop_types_1.default.bool.isRequired,
    color: prop_types_1.default.string.isRequired,
    color_border: prop_types_1.default.string.isRequired,
    transparent_border: prop_types_1.default.bool.isRequired,
    position_vert: prop_types_1.default.string.isRequired,
    position_horiz: prop_types_1.default.string.isRequired,
    font_size: prop_types_1.default.number.isRequired,
    font_weight: prop_types_1.default.bool.isRequired,
    font_style: prop_types_1.default.bool.isRequired,
    font_uppercase: prop_types_1.default.bool.isRequired,
    label_width: prop_types_1.default.number.isRequired,
    label_height: prop_types_1.default.number.isRequired,
    x: prop_types_1.default.number.isRequired,
    y: prop_types_1.default.number.isRequired,
    x_label: prop_types_1.default.number.isRequired,
    y_label: prop_types_1.default.number.isRequired,
};
exports.TagsGroupPropTypes = {
    group_name: prop_types_1.default.string.isRequired,
    show_legend: prop_types_1.default.bool.isRequired,
    color_map: prop_types_1.default.string.isRequired,
    tags: prop_types_1.default.objectOf(prop_types_1.default.shape({
        name: prop_types_1.default.string.isRequired,
        shape: prop_types_1.default.string,
        color: prop_types_1.default.string,
        selected: prop_types_1.default.bool.isRequired,
    }).isRequired).isRequired,
    banner: prop_types_1.default.string.isRequired
};
exports.TagsCatalogPropTypes = prop_types_1.default.objectOf(prop_types_1.default.shape(exports.TagsGroupPropTypes).isRequired).isRequired;
//-------------------------
exports.SankeyDataPropTypes = {
    version: prop_types_1.default.string.isRequired,
    file_name: prop_types_1.default.string,
    agregation: prop_types_1.default.shape({
        dimension: prop_types_1.default.string.isRequired,
        level: prop_types_1.default.number.isRequired,
    }).isRequired,
    user_scale: prop_types_1.default.number.isRequired,
    accordeonToShow: prop_types_1.default.arrayOf(prop_types_1.default.string.isRequired).isRequired,
    style_node: prop_types_1.default.objectOf(prop_types_1.default.shape(exports.SankeyNodePropTypes).isRequired).isRequired,
    style_link: prop_types_1.default.objectOf(prop_types_1.default.shape(exports.SankeyLinkPropTypes).isRequired).isRequired,
    // icon_catalog: PropTypes.object.isRequired,
    // icon_catalog: PropTypes.objectOf(PropTypes.objectOf(PropTypes.string)).isRequired,
    icon_catalog: prop_types_1.default.objectOf(prop_types_1.default.string).isRequired,
    show_structure: prop_types_1.default.bool.isRequired,
    fit_screen: prop_types_1.default.bool.isRequired,
    height: prop_types_1.default.number.isRequired,
    width: prop_types_1.default.number.isRequired,
    h_space: prop_types_1.default.number.isRequired,
    v_space: prop_types_1.default.number.isRequired,
    left_shift: prop_types_1.default.number.isRequired,
    right_shift: prop_types_1.default.number.isRequired,
    max_shift: prop_types_1.default.number.isRequired,
    legend_position: prop_types_1.default.arrayOf(prop_types_1.default.number.isRequired).isRequired,
    nodes: prop_types_1.default.objectOf(prop_types_1.default.shape(exports.SankeyNodePropTypes).isRequired).isRequired,
    links: prop_types_1.default.objectOf(prop_types_1.default.shape(exports.SankeyLinkPropTypes).isRequired).isRequired,
    labels: prop_types_1.default.objectOf(prop_types_1.default.shape(exports.SankeyLabelPropTypes).isRequired).isRequired,
    display_style: prop_types_1.default.shape({
        node_font_size: prop_types_1.default.number.isRequired,
        link_font_size: prop_types_1.default.number.isRequired,
        sector_uppercase: prop_types_1.default.bool.isRequired,
        sector_bold: prop_types_1.default.bool.isRequired,
        sector_italic: prop_types_1.default.bool.isRequired,
        product_uppercase: prop_types_1.default.bool.isRequired,
        product_bold: prop_types_1.default.bool.isRequired,
        product_italic: prop_types_1.default.bool.isRequired,
        unit: prop_types_1.default.bool.isRequired,
        filter: prop_types_1.default.number.isRequired,
        filter_label: prop_types_1.default.number.isRequired,
        global_curvature: prop_types_1.default.number.isRequired,
        null_flux: prop_types_1.default.bool.isRequired,
        font_family: prop_types_1.default.arrayOf(prop_types_1.default.string.isRequired).isRequired,
        node_font_family_selected: prop_types_1.default.string.isRequired,
        link_font_family_selected: prop_types_1.default.string.isRequired
    }).isRequired,
    grid_square_size: prop_types_1.default.number.isRequired,
    grid_visible: prop_types_1.default.bool.isRequired,
    static_sankey: prop_types_1.default.bool.isRequired,
    nodeTags: exports.TagsCatalogPropTypes,
    dataTags: exports.TagsCatalogPropTypes,
    fluxTags: exports.TagsCatalogPropTypes,
    colorMap: prop_types_1.default.string.isRequired,
    legend_width: prop_types_1.default.number.isRequired,
    view: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        id: prop_types_1.default.string.isRequired,
        view_data: prop_types_1.default.object.isRequired,
        nom: prop_types_1.default.string.isRequired,
        details: prop_types_1.default.string.isRequired
    }).isRequired).isRequired
};
